import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { DataTableResult } from '../../../../shared/services/global/global.models';
import { Company, CompanyFileGroups, CompanyListItem, SimulationInput, SimulationResponse } from './companies.models';

@Injectable()
export class CompaniesService
{
	// constructor
	constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string)
	{

	}

	// get filtered
	public getFiltered(filters): Observable<DataTableResult<CompanyListItem>>
	{
		return this.http.post<DataTableResult<CompanyListItem>>(`${this.baseUrl}api/admin/bonus/companies/getList`, filters);
	}

	// get single
	public getSingle(id: string): Observable<Company>
	{
		return this.http.get<Company>(`${this.baseUrl}api/admin/bonus/companies/getSingle/${id !== null ? id : ""}`);
	}

	// insert/update
	public insertUpdate(company: Company): Observable<Company>
	{
		return this.http.post<Company>(`${this.baseUrl}api/admin/bonus/companies/insertUpdate`, company);
	}

	// get file types configurations
	public getFileTypesConfigurations(companyId: string, bonusTypeId: number, scopeTypeId: number): Observable<Array<CompanyFileGroups>>
	{
		return this.http.get<Array<CompanyFileGroups>>(`${this.baseUrl}api/admin/bonus/companies/getFileTypesConfigurations/${companyId}/${bonusTypeId}/${scopeTypeId}`);
	}

	// insert file type configuration
	public insertFileTypeConfiguration(model)
	{
		return this.http.post(`${this.baseUrl}api/admin/bonus/companies/insertFileTypeConfiguration`, model);
	}

	// edit file type position
	public editFileTypePosition(model)
	{
		return this.http.post(`${this.baseUrl}api/admin/bonus/companies/editFileTypePosition`, model);
	}

	// delete file type configuration
	public deleteFileTypeConfiguration(configurationId: string)
	{
		return this.http.delete(`${this.baseUrl}api/admin/bonus/companies/deleteFileTypeConfiguration/${configurationId}`);
	}

	// simulation
	public simulation(model: SimulationInput): Observable<Array<SimulationResponse>>
	{
		return this.http.post<Array<SimulationResponse>>(`${this.baseUrl}api/admin/bonus/companies/simulation`, model);
	}
}